import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import '../../services/GlobalVariables'
import axios from 'axios'

const API_URL = global.SET_API_URL + 'parties/'

const initialState = {
    parties: [],
    partyCategories: [],
    isLoading: false,
    isError: false,
    isSuccess: false,
    message: ""
}

export const addNewParty = createAsyncThunk('partiesInf/ani', async (partyData, thunkAPI) => {
    try {
        const result = await axios.post(API_URL + 'addNewParty', partyData)
        return result.data
    } catch (error) {
        const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
        return thunkAPI.rejectWithValue(message)
    }
})

export const getAllParties = createAsyncThunk('partiesInf/gap', async (_, thunkAPI) => {
    try {
        const result = await axios.get(API_URL + 'getAllParties')
        return result.data
    } catch (error) {
        const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
        return thunkAPI.rejectWithValue(message)
    }
})

export const updateParty = createAsyncThunk('partiesInf/update', async (partyData, thunkAPI) => {
    try {
        const result = await axios.put(API_URL + 'updateParty/' + partyData.PartyCode, partyData)
        return result.data
    } catch (error) {
        const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
        return thunkAPI.rejectWithValue(message)
    }
})

export const importParties = createAsyncThunk('partiesInf/import', async (parties, thunkAPI) => {
    try {
        const result = await axios.post(API_URL + 'importParties', { parties })
        return result.data
    } catch (error) {
        const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
        return thunkAPI.rejectWithValue(message)
    }
})
export const getPartyCategories = createAsyncThunk('partiesInf/categories', async (_, thunkAPI) => {
    try {
        const result = await axios.get(API_URL + 'getPartyCategories')
        return result.data
    } catch (error) {
        const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
        return thunkAPI.rejectWithValue(message)
    }
})
export const partiesInformationSlice = createSlice({
    name: 'menus',
    initialState,
    reducers: {
        reset: (state) => {
            state.parties = []
            state.isLoading = false
            state.isError = false
            state.isSuccess = false
            state.message = ""
        }

    },
    extraReducers: (builder) => {
        builder
            .addCase(addNewParty.pending, (state) => {
                state.isLoading = true
            })
            .addCase(addNewParty.fulfilled, (state, action) => {
                state.isLoading = false
                state.isSuccess = true
                state.parties.push(action.payload)
            })
            .addCase(addNewParty.rejected, (state, action) => {
                state.isLoading = false
                state.isError = true
                state.message = action.payload
            })
            .addCase(getAllParties.pending, (state) => {
                state.isLoading = true
            })
            .addCase(getAllParties.fulfilled, (state, action) => {
                state.isLoading = false
                state.isSuccess = true
                state.parties = action.payload
            })
            .addCase(getAllParties.rejected, (state, action) => {
                state.isLoading = false
                state.isError = true
                state.message = action.payload
            })
            .addCase(updateParty.pending, (state) => {
                state.isLoading = true
            })
            .addCase(updateParty.fulfilled, (state, action) => {
                state.isLoading = false
                state.isSuccess = true
                const index = state.parties.findIndex((party) => party.PartyCode === action.payload.PartyCode)
                if (index !== -1) state.parties[index] = action.payload
            })
            .addCase(updateParty.rejected, (state, action) => {
                state.isLoading = false
                state.isError = true
                state.message = action.payload
            })
            .addCase(getPartyCategories.fulfilled, (state, action) => {
                state.partyCategories = action.payload
            })
            .addCase(getPartyCategories.rejected, (state, action) => {
                state.isError = true
                state.message = action.payload
            })    }
})

export const { reset } = partiesInformationSlice.actions

export default partiesInformationSlice.reducer